import { requireProvider } from '@/router/guards/authGuards';
import { checkSitterOnboarding } from '@/router/guards/completionGuards';
import combineGuards from '@/router/guards/helpers';

const bestPracticesRoutes = [
  {
    path: '/account/providers/best-practices/safe-and-sound',
    name: 'safe-and-sound-best-practices',
    component: () => import('@/apps/account/provider/best_practices/TrustedCaregiverVideo.vue'),
    beforeEnter: combineGuards([requireProvider, checkSitterOnboarding]),
    meta: {
      pageTrackingName: 'Safe and Sound Best Practices',
      pageTrackingTitle: 'Safe and Sound Best Practices',
    },
  },
];

export default bestPracticesRoutes;
